/* Aubelys · sections aub-noc-* : galerie, couleur + offres (une couleur par lampe), ajout au panier (tiroir du thème), barre d'achat fixe, vidéos lues quand visibles, carrousel d'avis. */
(function () {
  'use strict';
  /* le fichier est inclus par plusieurs sections : une seule exécution, sinon chaque clic partirait plusieurs fois */
  if (window.aubNocInit) return;
  window.aubNocInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var DOT = { noir: '#111', blanc: '#f3f1ec', rose: '#e9c3c6' };

  /* galerie : miniatures */
  $$('[data-aubn-gal]').forEach(function (g) {
    var tr = $('.aubn-gal__track', g), th = $$('.aubn-thumbs button', g);
    if (!tr) return;
    th.forEach(function (b, i) { b.onclick = function () { tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' }); }; });
    tr.addEventListener('scroll', function () { var k = Math.round(tr.scrollLeft / tr.clientWidth); th.forEach(function (b, i) { b.setAttribute('aria-current', String(i === k)); }); }, { passive: true });
  });

  $$('[data-aubn-buy]').forEach(function (col) {
    var variants = [];
    try { variants = JSON.parse($('[data-aubn-variants]', col).textContent) || []; } catch (e) {}
    var offers = $$('.aubn-offer', col), btn = $('[data-aubn-atc]', col), msg = $('[data-aubn-msg]', col), cartEl = $('cart-drawer');
    var sw = $$('.aubn-sw__b input', col), swl = $('[data-aubn-swl]', col);
    var sticky = $('[data-aubn-sticky]'), sp = $('[data-aubn-sp]'), ss = $('[data-aubn-ss]');
    var color = function () { var c = sw.filter(function (x) { return x.checked; })[0]; return c ? c.value : (variants[0] && variants[0].options[0]); };
    var paintDots = function () { $$('[data-aubn-row]', col).forEach(function (r) { var d = $('[data-aubn-dot]', r), s = $('select', r); if (d && s) d.style.background = DOT[s.value.toLowerCase()] || '#999'; }); };
    var on = function () { return offers.filter(function (o) { return o.classList.contains('is-on'); })[0]; };
    var sync = function () {
      offers.forEach(function (o) { o.classList.toggle('is-on', $('input', o).checked); });
      var o = on();
      if (o && sp) { var t = +o.getAttribute('data-total'), f = +o.getAttribute('data-full'); sp.textContent = eur(t); ss.textContent = eur(f); ss.hidden = !(f > t); }
    };
    offers.forEach(function (o) { $('input', o).addEventListener('change', sync); });
    /* la couleur choisie en haut se reporte sur chaque lampe des offres */
    sw.forEach(function (x) { x.addEventListener('change', function () { if (swl) swl.textContent = x.value; $$('[data-aubn-row] select', col).forEach(function (s) { s.value = x.value; }); paintDots(); }); });
    $$('[data-aubn-row] select', col).forEach(function (s) { s.addEventListener('change', paintDots); });
    sync(); paintDots();
    var find = function (c) { return variants.filter(function (v) { return v.options[0] === c; })[0]; };
    if (!btn) return;
    btn.addEventListener('click', function () {
      var o = on(); if (!o) return;
      var picks = $$('[data-aubn-row] select', o).map(function (s) { return s.value; });
      if (!picks.length) picks = [color()];
      var counts = {}, order = [], bad = false;
      picks.forEach(function (c) { var v = find(c); if (!v || !v.available) { bad = true; return; } if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); } counts[v.id]++; });
      if (bad) { if (msg) msg.textContent = 'Cette couleur n’est plus disponible.'; return; }
      var body = { items: order.map(function (id) { return { id: id, quantity: counts[id] }; }) };
      if (cartEl) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { if (msg) msg.textContent = res.j.description || 'Impossible d’ajouter la lampe au panier.'; return; }
          if (msg) msg.textContent = '';
          if (cartEl && typeof cartEl.renderContents === 'function') { cartEl.renderContents(res.j); cartEl.classList.remove('is-empty'); var inn = cartEl.querySelector('.drawer__inner'); if (inn) inn.classList.remove('is-empty'); if (typeof cartEl.open === 'function' && !cartEl.classList.contains('active')) cartEl.open(); }
          else window.location = root + 'cart';
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Une erreur est survenue, réessayez.'; });
    });
    /* barre fixe : visible quand le bouton principal est sorti de l'écran par le haut ; elle ajoute l'offre choisie */
    if (sticky) {
      var sb = $('[data-aubn-sticky-btn]', sticky);
      if (sb) sb.addEventListener('click', function () { btn.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', String(!show)); if (sb) sb.tabIndex = show ? 0 : -1;
        }).observe(btn);
      }
    }
  });

  /* carrousel d'avis (mobile) */
  $$('[data-aubn-reviews]').forEach(function (rv) {
    var tr = $('.aubn-rv__track', rv);
    $$('.aubn-rv__nav button', rv).forEach(function (b) { b.onclick = function () { tr.scrollBy({ left: (+b.getAttribute('data-dir')) * tr.clientWidth, behavior: 'smooth' }); }; });
  });

  /* vidéos : chargées et lues seulement quand elles sont à l'écran, muettes, en boucle (comme la source) */
  var vids = $$('video[data-aubn-autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.hasAttribute('data-src')) { v.src = v.getAttribute('data-src'); v.removeAttribute('data-src'); }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '100px' });
    vids.forEach(function (v) { io.observe(v); });
  }
})();
